import modal from './modal';
import tab from './tab';
import download from './download';
import cache from './cache';
import auth from './auth';
// 预设动画
import animate from '@/animate';
import useUserStore from '@/store/modules/user';
import { download as dl } from '@/utils/request';
import { useDict } from '@/utils/dict';
import { getConfigKey, updateConfigByKey } from '@/api/system/config';
import { parseTime, addDateRange, handleTree, selectDictLabel, selectDictLabels } from '@/utils/ruoyi';
import { formatCoordinate } from '@/utils/formatCoordinate';
import i18n from '@/lang/index';
const { t } = i18n.global;
import { App } from 'vue';
/**
 * 检查设备是否支持有能力集
 * @param id 设备类型的id 或 code
 * @param capCode
 */
const checkHasCapability = (id: string, capCode: string) => {
  const { capabilities, capabMap } = useUserStore();
  let capObj = capabilities.find(
    (cap) => (cap?.id == id && cap?.capability.includes(capCode)) || (cap?.code == id && cap?.capability.includes(capCode))
  );
  if (capObj) {
    return true;
  } else {
    modal.msgWarning(t('QuestList.currentDevice', { field: capabMap[capCode] || '' }));
    return false;
  }
};
export default function installPlugin(app: App) {
  // 页签操作
  app.config.globalProperties.$tab = tab;

  // 模态框对象
  app.config.globalProperties.$modal = modal;

  // 缓存对象
  app.config.globalProperties.$cache = cache;

  // 下载文件
  app.config.globalProperties.$download = download;

  // 认证对象
  app.config.globalProperties.$auth = auth;

  // 格式化经纬度
  app.config.globalProperties.formatCoord = formatCoordinate;

  // 全局方法挂载
  app.config.globalProperties.useDict = useDict;
  app.config.globalProperties.getConfigKey = getConfigKey;
  app.config.globalProperties.updateConfigByKey = updateConfigByKey;
  app.config.globalProperties.download = dl;
  app.config.globalProperties.parseTime = parseTime;
  app.config.globalProperties.handleTree = handleTree;
  app.config.globalProperties.addDateRange = addDateRange;
  app.config.globalProperties.selectDictLabel = selectDictLabel;
  app.config.globalProperties.selectDictLabels = selectDictLabels;
  app.config.globalProperties.hasCapability = checkHasCapability;
  app.config.globalProperties.hasPermi = auth.hasPermi;
  app.config.globalProperties.animate = animate;
  app.config.globalProperties.ALTH = 0;
}
